import React from "react";
import { PartnerNavbar, PartnerFooter } from "./marketingAgency/shared";
import { HeroSection, VerticalReadinessStrip } from "./marketingAgency/hero";
import { HowItWorksSection } from "./marketingAgency/howItWorks";
import { RoiCalculatorSection } from "./marketingAgency/roiCalculator";
import { SandboxSection } from "./marketingAgency/sandbox";
import { PartnerLiveDeploymentSection } from "./marketingAgency/liveDeployment";
import { SpecificationsSection } from "./marketingAgency/specifications";
import { ComparisonTableSection } from "./marketingAgency/comparisonTable";
import { ClientBenefitsSection } from "./marketingAgency/clientBenefits";
import { AgencyBenefitsSection } from "./marketingAgency/agencyBenefits";
import { TiersSection } from "./marketingAgency/tiers";
import { CreditPoolSection } from "./marketingAgency/creditPool";
import { MarginProtectionSection } from "./marketingAgency/marginProtection";
import { PartnerFormSection } from "./marketingAgency/partnerForm";

const MarketingAgency = () => (
  <div className="partner-landing min-h-screen" data-testid="marketing-agency-page">
    <PartnerNavbar />
    <HeroSection />
    <VerticalReadinessStrip />
    <PartnerLiveDeploymentSection />
    <HowItWorksSection />
    <RoiCalculatorSection />
    <SandboxSection />
    <SpecificationsSection />
    <ComparisonTableSection />
    <ClientBenefitsSection />
    <AgencyBenefitsSection />
    <TiersSection />
    <CreditPoolSection />
    <MarginProtectionSection />
    <PartnerFormSection />
    <PartnerFooter />
  </div>
);

export default MarketingAgency;
